import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@/icons';
import { useTheme } from '../contexts/ThemeContext';

interface SignupBackButtonProps {
    onClick: () => void;
    disabled?: boolean;
}

export const SignupBackButton: React.FC<SignupBackButtonProps> = ({ onClick, disabled }) => {
    const theme = useTheme();

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: theme.spacing.xs,
                width: '100%',
                marginTop: theme.spacing.sm,
                padding: `${theme.spacing.sm} ${theme.spacing.md}`,
                background: 'none',
                border: 'none',
                color: disabled ? theme.colors.text.muted : theme.colors.text.secondary,
                fontSize: theme.typography.fontSize.sm,
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
            }}
        >
            <FontAwesomeIcon icon={faArrowLeft} style={{ fontSize: '12px' }} />
            Back
        </button>
    );
};
